export enum ClassStatus {
  ARCHIVED = 'archived',
  FINISHED = 'finished',
  GRADUATED = 'graduated',
  IN_PROGRESS = 'in_progress',
}
